import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {User} from 'projects/core/src/lib/login/data/user';
import {Any} from 'json2typescript';
import {Project} from '../../project-misc/data/project/project';

export type TimeCardType = 'WORK' | 'PAID_BREAK' | 'UNPAID_BREAK' | 'VACATION' | 'SICK_HOURS' | 'UNPAID_VACATION';

@JsonObject('model.time_card.TimeCard')
export class TimeCard extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(String, 'notes')
  notes?: string;

  @JsonProperty(Boolean, 'approved')
  approved?: boolean;

  @JsonProperty(Boolean, 'closedBySystem')
  closedBySystem?: boolean;

  @JsonProperty(Boolean, 'rejected')
  rejected?: boolean;

  // TODO FIX THIS
  @JsonProperty(Any, 'duration')
  duration?: any;

  @JsonProperty(Number, 'lateMinutes')
  lateMinutes?: number;

  @JsonProperty(String, 'startTime')
  startTime?: string;

  @JsonProperty(String, 'finishTime')
  finishTime?: string;

  @JsonProperty(User, 'user')
  user?: User;

  @JsonProperty(Number, 'punchInLat')
  punchInLat?: number;

  @JsonProperty(Number, 'punchInLong')
  punchInLong?: number;

  @JsonProperty(Number, 'punchOutLat')
  punchOutLat?: number;

  @JsonProperty(Number, 'punchOutLong')
  punchOutLong?: number;

  @JsonProperty(String, 'type')
  type?: TimeCardType;

  @JsonProperty(Project, 'job')
  job?: Project;

}
